// extracted by mini-css-extract-plugin
module.exports = {"bannerLink":"Banner__bannerLink__1BJ-n","bannerImage":"Banner__bannerImage__3MiCv"};